const isMRN = false;
export const isdpHost = isMRN ? false : location.host.indexOf('dianping') > -1 || location.host.indexOf('51ping') > -1;
// 埋点id
export const FLIGHT_SPECIAL_PRICE_ROOT_MV = 'b_daodian_lowcode_94grs8zd_mv';
export const CLICK_CARD_MC_BID = 'b_daodian_lowcode_ctka5l41_mc';
export const SHOW_MORE_MC_BID = 'b_daodian_lowcode_17i8c4am_mc';
export const SWITCH_CONTENT_MC_BID = 'b_daodian_lowcode_72lhimbt_mc';
